import { CircleHelp, LogOut, ShieldCheck, UserRound } from "lucide-react";
import { Button } from "@/components/ui/button";

const ClientOnboardingLayout = ({ children, onLogout }) => (
  <div className="min-h-screen bg-gray-50 font-sans text-gray-800">
    <header className="sticky top-0 z-40 border-b border-gray-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-screen-2xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-500 text-white shadow-theme-xs">
            <ShieldCheck className="h-5 w-5" />
          </span>
          <div className="flex items-center gap-3">
            <span className="text-lg font-semibold text-gray-950">Proovam</span>
            <span className="hidden h-5 w-px bg-gray-200 sm:block" />
            <span className="hidden text-sm text-gray-500 sm:block">Set up Proovam</span>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-4">
          <a
            href="mailto:support@proovam.com"
            className="inline-flex h-10 items-center gap-2 rounded-lg px-3 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
          >
            <CircleHelp className="h-4 w-4" />
            <span className="hidden sm:inline">Help</span>
          </a>
          <div className="hidden items-center gap-2 border-l border-gray-200 pl-4 md:flex">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-50 text-brand-500">
              <UserRound className="h-4 w-4" />
            </span>
            <span className="text-sm font-medium text-gray-700">Client Admin</span>
          </div>
          <Button variant="ghost" size="sm" onClick={onLogout} aria-label="Sign out" className="text-gray-600 hover:text-rose-600">
            <LogOut className="h-4 w-4 sm:mr-2" />
            <span className="hidden sm:inline">Sign out</span>
          </Button>
        </div>
      </div>
    </header>
    <main>{children}</main>
  </div>
);

export default ClientOnboardingLayout;
